<app-banner></app-banner>
<app-about-us></app-about-us>
<app-how-to-buy></app-how-to-buy>
<app-roadmap></app-roadmap>
<app-faq></app-faq>
